import React, { useState, Suspense } from "react";
import { useEffect } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";
import reactWrapper from "@harbor/elements/utils/react/wrapper";

//components
import AppHOC from "../../../../generics/AppHOC";
import Spinner from "../../../../common/Spinner";
import BulletColumnAndLineChart from "../../../../common/BulletColumnAndLineChart";

// lazy loading components
const ErrorComponent = React.lazy(() =>
  import("../../../../common/ErrorComponent")
);
const NoDataAvailable = React.lazy(() =>
  import("../../../../common/NoDataAvailable")
);

//utils
import useApplicationInfoHooks from "../../useApplicationInfoHooks";
import {
  getLocalStorageFlag,
  getTipBulletColumnChart
} from "../../../../utils/common";
import { validateProps } from "../../../../utils/waniCommon";
import { EXPORT_CSV_LABELS } from "../../../../utils/enums";
//style
import css from "../../insightsAppMagneticStyle.less";
import useI18n from "../../../../i18n/useI18n";

const mapStateToProps = state => {
  return {
    predictiveNetworks: state.vanalytics.predictiveNetworks
  };
};

const [HbrCard] = reactWrapper(["hbr-card"]);

const UserExperienceChrt = props => {
  const { tViews } = useI18n('views');
  const { endpoints } = props.globalFilter;
  const {
    selectedOverlay,
    selectedSite,
    onboardingStatus,
    globalAltoId,
    appGroup
  } = validateProps(props.globalFilter);

  const { state, getChartData } = useApplicationInfoHooks();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (onboardingStatus === "ACTIVE") {
      setIsLoading(true);
      getChartData(globalAltoId, selectedOverlay, endpoints);
    } else {
      setIsLoading(false);
    }
  }, [appGroup]);

  useEffect(() => {
    if (onboardingStatus === "ACTIVE") {
      if (state.chartData?.chartList?.length !== undefined) {
        setIsLoading(true);
        getChartData(globalAltoId, selectedOverlay, endpoints);
      }
    }
  }, [selectedSite]);

  useEffect(() => {
    if (state.isFetchingUserChartDone) setIsLoading(false);
  }, [state.isFetchingUserChartDone, state.isFetchingUserChartError]);

  if (isLoading) {
    return (
      <div className={css["user-experience-chart"]}>
        <div data-cy="spinner-userExperienceChart">
          <Spinner />
        </div>
      </div>
    );
  } else {
    if (state.isFetchingUserChartError.errorObject) {
      return (
        <Suspense fallback={<Spinner />}>
          <ErrorComponent
            {...state.isFetchingUserChartError.errorObject}
            width={"200px"}
            className={"super-small-dashlet-error"}
          />
        </Suspense>
      );
    } else if (_.isEmpty(state.chartData?.chartList)) {
      return (
        <HbrCard
          className={css["user-experience-chart"]}
          data-cy="user-experience-chart"
        >
          <Suspense fallback={<Spinner />}>
            <NoDataAvailable text={tViews('syncronizedChartNoData')} />
          </Suspense>
        </HbrCard>
      );
    } else {
      return (
        <HbrCard
          className={css["user-experience-chart"]}
          data-cy="user-experience-chart"
        >          
          <div className="bullet-chart-view">
          <div className="hbr-type-h2">
            {tViews('appGroupWidget.recommendations')}
          </div>
            <BulletColumnAndLineChart
              data={state.chartData.chartList}
              chartName={EXPORT_CSV_LABELS.PN_USEREXPERIENCE_CHART}
              chartsData={[]}
              chartAriaLabel={tViews('a11yLabels.pwPredictivePathRecommendations')}
              isTitleShown={true}
              chartProps={{
                site: parseInt(getLocalStorageFlag("actionCardSite")),
                isSeriesConnected: false,
                chartId: "isLoaded_chart",
                useCompactScrollbarDateLabels: true,
                tooltipHTML: getTipBulletColumnChart(),  
                ariaLabel: tViews('a11yLabels.pwPredictivePathRecommendationsChart'), 
                zoomInDaysCount: 2,
                leftTitleForY:
                  tViews('appGroupPerSite.userExpChartActiveUsrLabel'),
                rightTitleForY: tViews('appGroupPerSite.meanQuality'),
                legendLabels: [
                  tViews('appGroupPerSite.userExpChartRecomLabel'),
                  tViews('appGroupPerSite.userExpChartCurrentPathLabel'),
                  tViews('appGroupPerSite.userExpChartActiveUsrLabel')
                ]
              }}
            />
          </div>
        </HbrCard>
      );
    }
  }
};

UserExperienceChrt.propTypes = {
  globalFilter: PropTypes.object
};

export default (
  connect(mapStateToProps)(AppHOC(UserExperienceChrt))
);
